export default __webpack_public_path__ + "static/media/eightPageHero.5f362888.jpg";